export default "__VITE_ASSET__BMiPG8pE__"